import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { CoursesMap, LangMap } from '@model/CoursesClass';
import { Notification } from '@model/Notification';
import { UserProfile } from '@model/User';
import { getNotifInfoByType } from '@utility/firebaseUtility';
import * as actions from "@redux-actions/"
import Close2 from "@images/svg-icons/close2.svg";
import { motion } from 'framer-motion';
import useLivestreamCountdown from '@hooks/useLivestreamCountdown';
import { truncateLabel } from '@utility/Api';
import { useSelector } from '@hooks/redux';

type NotificationPreviewProps = {
};

const NotificationPreview = ({ }: NotificationPreviewProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const notifPreviews: Notification[] = useSelector((state) => state.firebase.notifPreviews);
  const coursesMap: CoursesMap[] = useSelector((state) => state.course.coursesMap);
  const lang: LangMap = useSelector((state) => state.utils.lang);
  const langNotif = useSelector((state) => state.utils.langNotif);
  const userProfile: UserProfile = useSelector((state) => state.user.userProfile);

  const [actualPreview, setActualPreview] = useState(null);
  const [timeoutClose, setTimeoutClose] = useState(null);
  const [seeMore, setSeeMore] = useState(false);

  const variants = {
    initial: {
      y: '-12px',
      opacity: 0,
    },
    enter: {
      y: '0px',
      opacity: 1,
    },
    exit: {
      x: '-12px',
      opacity: 0,
    },
  }

  useEffect(() => {
    let newActualPreview = null;
    if (notifPreviews?.length > 0 && coursesMap && lang && langNotif && userProfile) {
      newActualPreview = getNotifInfoByType(notifPreviews[0], coursesMap, lang, langNotif, userProfile.timezone ? userProfile.timezone : 'UTC');
      newActualPreview.notif = notifPreviews[0];

      if (actualPreview?.notif?.id !== newActualPreview.notif?.id) {
        //show preview for 7 seconds
        const newTimeoutClose = setTimeout(() => {
          closePreview();
        }, 7000);
        setTimeoutClose(newTimeoutClose);
      }
    }
    setActualPreview(newActualPreview);

  }, [notifPreviews]);

  const [countdown] = useLivestreamCountdown(actualPreview, actualPreview?.notif);

  const closePreview = () => {
    if (timeoutClose) {
      clearTimeout(timeoutClose);
    }

    setSeeMore(false);
    dispatch(actions.popNotificationPreview());
  }

  const handleActionButton = (notif: Notification, action) => {
    //close preview
    dispatch(actions.popNotificationPreview());

    //handle action
    dispatch(actions.handleNotifAction(
      notif,
      action,
      history
    ));
  };

  const handleSeeMore = () => {
    setSeeMore(true)
  }

  return (
    <>
      {actualPreview &&
        <motion.div
          key={actualPreview.notif.id}
          className="notif-preview__container"
          variants={variants}
          initial="initial"
          animate="enter"
          exit="exit"
          transition={{ ease: "easeInOut", duration: 0.3 }}
        >
          {/* <div className="notif-preview__container"> */}
          <div className="notif-preview">
            {/* <div className="notif-preview__timestamp">
              <span>{getElapsedTime(actualPreview.notif, lang, userProfile?.timezone)}</span>
              {!actualPreview.notif.read && (
                <div className="not-read-marker"></div>
              )}
            </div> */}
            <div className="notif-preview__content">
              <div className={"notif-preview__type " + (actualPreview.iconClassName ? actualPreview.iconClassName : '')}>
                {actualPreview.icon}
              </div>
              <div className="notif-preview__text">
                {/* <p className={"notif-preview__title desktop " + (actualPreview.titleClassName ? actualPreview.titleClassName : '')}
                  dangerouslySetInnerHTML={printHTML(actualPreview.title.replace('{countdown}', '<span class="livestream-red">' + countdown + '</span>'))}
                /> */}
                <p className="notif-preview__descr">{seeMore ? actualPreview.description : truncateLabel(actualPreview.description, 100)}
                  {
                    (actualPreview.description?.length > 100 && !seeMore) &&
                    <>
                      {" "}
                      <span className="notif-preview__action action underline" onClick={handleSeeMore}>
                        {lang?.SEE_MORE}
                      </span>
                    </>
                  }
                </p>
                <p className="notif-preview__action" onClick={() => handleActionButton(actualPreview.notif, actualPreview.action)}>
                  {actualPreview.actionText}
                </p>
              </div>
              <div className="notif-preview__close" onClick={closePreview}>
                <Close2 />
              </div>
            </div>
          </div>
          {/* </div> */}
        </motion.div>
      }
    </>
  )
}

export default NotificationPreview;
